.slide {
    margin: 0;
}

.link {
    display: block;
    text-decoration: none;
    color: inherit;
}

.imageContainer {
    display: block;
    aspect-ratio: 437 / 335;
    overflow: hidden;
}

.image {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.copy {
    display: flex;
    flex-direction: column;
    gap: var(--spacer-4);
    padding-block: var(--spacer-16);
}

.heading {
    font: var(--font-h-24);
}

.body {
    font: var(--font-p-16);
}
